import axios from '@/axios'
import Vue from 'vue'

const state = {
  messages: []
};

const actions = {
  fetchMessages({ commit }, config) {
    return axios.get('messages', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_MESSAGES', r.data.messages)
        } else {
          throw new Error("Messages forbidden");
        }
      })
  }
};

const mutations = {
  SAVE_MESSAGES(state, messages) {
    Vue.set(state, 'messages', messages);
  }
};

export default {
  state,
  actions,
  mutations
}
